/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const UserTick = ({ color = 'currentColor', ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
    data-palette="UserTick">
    <path
      fill={color}
      d="m19.392 12.221 1.239 1.248-5.78 5.834-3.073-3.098 1.24-1.248 1.832 1.841 4.542-4.577ZM10.45 4.697a3.541 3.541 0 1 1 0 7.082 3.541 3.541 0 0 1 0-7.082Zm0 1.77a1.77 1.77 0 1 0 0 3.541 1.77 1.77 0 0 0 0-3.54Zm0 6.197c.601 0 1.327.08 2.133.23l-1.478 1.478-.655-.026c-2.63 0-5.4 1.292-5.4 1.859v.974h5.488l1.682 1.682H3.369v-2.656c0-2.355 4.718-3.541 7.082-3.541Z"
    />
  </svg>
);
export default UserTick;
